<!-- Row -->
<div class="row">
    <!-- Column -->
    <div class="col-lg-4 col-xlg-3 col-md-5">
        <div class="card">
            <div class="user-bg"> <img class="img-responsive card-img" alt="user" [src]="ImageSrc"> </div>
            <div class="card-body">
                <!-- .row -->
                <div class="row text-center m-t-10">
                    <div class="col-md-12">
                        <strong> Name</strong>
                        <p>{{admin.name}}</p>
                    </div>

                </div>
                <hr>
                <!-- /.row -->
                <!-- .row -->
                <div class="row text-center m-t-10">
                    <div class="col-md-6 col-6 b-r"><strong>Email ID</strong>
                        <p>{{admin.email}}</p>
                    </div>
                    <div class="col-md-6 col-6"><strong>Hotline</strong>
                        <p>{{admin.phone}}</p>
                    </div>
                </div>
                <!-- /.row -->
                <hr>
                <!-- .row -->
                <div class="row text-center m-t-10">
                    <div class="col-md-12"><strong>Address</strong>
                        <p *ngIf="admin"> {{admin | address}}
                        </p>
                    </div>
                </div>
                <hr>
                <br />

            </div>
        </div>
    </div>
    <!-- Column -->
    <!-- Column -->
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">

            <!-- Nav tabs -->
            <div style="padding-top: 10px; padding-right: 10px ;">
                <ul class="nav nav-tabs profile-tab" role="tablist">
                    <li class="nav-item"> <a class="nav-link" [ngClass]="{active: tab === 1}" data-toggle="tab"
                            href="javascript::void(0)" (click)="onclickTab(1)" role="tab">About</a> </li>
                    <!-- <li class="nav-item"> <a class="nav-link" [ngClass]="{active: tab === 2}" data-toggle="tab" href="javascript::void(0)" (click)="onclickTab(2)" role="tab">Update Details</a> </li> -->
                </ul>


            </div>
            <!-- Tab panes -->
            <div class="tab-content">

                <!--second tab-->
                <div class="tab-pane " [ngClass]="{active: tab === 1}" id="profile" role="tabpanel">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3 col-6 mb-10 b-r"> <strong> ID</strong>
                                <p class="text-muted">{{admin.username}}</p>
                            </div>
                            <div class="col-md-3 col-6 mb-10 b-r h-b"> <strong>Hotline</strong>
                                <p class="text-muted">{{admin.phone}}</p>
                            </div>
                            <div class="col-md-3 col-6 b-r"> <strong>City</strong>
                                <p class="text-muted">{{admin.city}}</p>
                            </div>
                            <div class="col-md-3 col-6"> <strong>State</strong>
                                <p class="text-muted">{{admin.state}}</p>
                            </div>
                        </div>
                        <hr>
                        <h3>Biography</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                            been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                            galley of type and scrambled it to make a type
                            specimen book. It has survived not only five centuries </p>
                        <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
                            passages, and more recently with desktop publishing software like Aldus PageMaker including
                            versions of Lorem Ipsum.</p>
                        <h4 class="font-medium m-t-30">Status: &nbsp; <span class="label "
                                [ngClass]="admin.active ? 'label-success' : 'label-primary'" style="padding: 10px;">
                                {{admin.active ? 'Active' : 'Inactive'}}</span></h4>

                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Column -->
</div>
<!-- Row -->
